
reasonType = [ {
	id : 'DEATH',
	name : 'Tử vong'
}, {
	id : 'TPD',
	name : 'Thương tật'
}, {
	id : 'CI',
	name : 'Bệnh hiểm nghèo'
}, {
	id : 'MED',
	name : 'Chăm sóc sức khỏe'
} ];